// https://gist.github.com/rostrovsky/d707c2160049d517677c9ff85c5a27ba
export function autoRowSpan(selector: string, mergeIndex: number = -1) {
    const table = document.querySelector(selector) as HTMLTableElement | null;
    if (!table) return;

    const rows = Array.from(table.rows);
    if (rows.length === 0) return;

    const colCount = rows[0].cells.length;

    for (let colIndex = 0; colIndex < colCount; colIndex++) {
        if (mergeIndex !== -1 && colIndex !== mergeIndex) continue;

        let prevCell: HTMLTableCellElement | null = null;
        let prevText = '';
        let spanCount = 1;

        for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
            const cell = rows[rowIndex].cells[colIndex];
            if (!cell) continue;

            const text = cell.textContent || '';
            if (prevCell && text === prevText) {
                cell.style.display = 'none';
                spanCount++;
            } else {
                if (prevCell && spanCount > 1) {
                    prevCell.rowSpan = spanCount;
                }
                prevCell = cell;
                prevText = text;
                spanCount = 1;
            }
        }

        if (prevCell && spanCount > 1) {
            prevCell.rowSpan = spanCount;
        }

        if (prevCell) prevCell.classList.add('bg-slate-200');
    }
}

export function autoRowSpanOld(selector: string, mergeIndex: number = -1) {
    var table = document.querySelector(selector) as HTMLTableElement;
    if (!table) {
        return
    }
    var rows = table.rows;
    if (!rows || !rows[0]) {
        return
    }

    // Iterate through each column
    for (var colIndex = 0; colIndex < rows[0].cells.length; colIndex++) {
        var prevCell = null;
        var prevCellText = '';
        var rowspan = 1;

        if (mergeIndex != -1 && colIndex != mergeIndex) {
            continue
        }

        // Iterate through each row
        for (var rowIndex = 0; rowIndex < rows.length; rowIndex++) {

            if (!rows[rowIndex]) {
                return
            }
            var cell = rows[rowIndex].cells[colIndex];
            if (cell == null) {
                continue
            }

            if (prevCell && cell.innerText === prevCellText) {
                // If this cell is the same as the previous one, hide it and increase rowspan
                cell.style.display = 'none';
                rowspan++;
                prevCell.rowSpan = rowspan;
                prevCell.style.background = "oklch(96.8% 0.007 247.896)"
            } else {
                // New cell content found, reset counters
                if (prevCell && rowspan > 1) {
                    prevCell.rowSpan = rowspan;
                }
                prevCell = cell;
                prevCellText = cell.innerText;
                rowspan = 1;
            }
        }

        // Ensure the last cell in the column gets its rowspan set
        if (prevCell && rowspan > 1) {
            prevCell.rowSpan = rowspan;
        }
    }
}

